<template>
  <div>
    <!-- Componente de notificaciones -->
    <notifications></notifications>

    <!-- Encabezado -->
    <div
      class="header pb-8 pt-6 pt-lg-6 d-flex align-items-center profile-header"
      style="
        min-height: 300px;
        background-size: cover;
        background-position: center top;
      "
    >
      <b-container fluid>
        <span class="mask" :style="{ background: 'linear-gradient(90deg, #4d545b, #33383e)', opacity: 0.8 }"></span>

        <b-container fluid class="d-flex align-items-center">
          <b-row>
            <b-col lg="7" md="10">
              <h1 class="display-2 text-white">Nueva Organización</h1>
            </b-col>
          </b-row>
        </b-container>
      </b-container>
    </div>

    <!-- Formulario -->
    <b-container fluid class="mt--6">
      <b-card>
        <form @submit.prevent="ingresarORG">
          <b-row class="form-group">
            <label class="col-md-2 col-form-label form-control-label"
              >NOMBRE ORGANIZACION:</label
            >
            <b-col md="10">
              <base-input
                v-model="datosORGnombre"
                placeholder="Ingrese Nombre de Organización"
              ></base-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <base-button
                type="success"
                @click="ingresarORG"
                :loading="isLoading"
              >
                <span v-if="!isLoading">Guardar</span>
                <span v-if="isLoading">Guardando...</span>
              </base-button>
              <base-button type="warning" @click="$router.push('/Org')"
                >Cancelar</base-button
              >
            </b-col>
          </b-row>
        </form>
      </b-card>
    </b-container>
    <TokenExpiredModal :show="showTokenExpiredModal"> </TokenExpiredModal>
  </div>
</template>

<script>
import axios from "axios";
import TokenExpiredModal from "../components/TokenExpiredModal.vue";

export default {
  components: { TokenExpiredModal },
  data() {
    return {
      datosORGid: "", // Data for ID input
      datosORGnombre: "", // Data for Name input
      isLoading: false, // Loading state for the button
      showTokenExpiredModal: false,
    };
  },
  methods: {
    async ingresarORG() {
      this.isLoading = true; // Set loading to true
      const token = localStorage.getItem("token");

      // Verificar token
      if (!this.checkToken()) {
        this.$notifications.addNotification({
          type: "danger", // Tipo de notificación (error)
          message: "Token no presente. Usuario no autenticado.",
        });
        this.isLoading = false; // Reset loading
        return;
      }

      // Validar campos
      if (!this.datosORGnombre) {
        this.$notifications.addNotification({
          type: "danger", // Tipo de notificación (error)
          message: "Por favor, complete todos los campos.",
        });
        this.isLoading = false; // Reset loading
        return;
      }

      const datos = {
        ID: this.datosORGid,
        NAME: this.datosORGnombre,
      };

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}/insertarDatosORG`,
          datos,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.success) {
          this.$notifications.addNotification({
            type: "success", // Tipo de notificación (éxito)
            message: "Datos insertados correctamente",
          });
          // Reset form fields after successful submission
          this.datosORGid = "";
          this.datosORGnombre = "";
        } else {
          this.$notifications.addNotification({
            type: "danger", // Tipo de notificación (error)
            message: response.data.message || "Error al insertar datos",
          });
        }
      } catch (error) {
        console.error("Error al insertar datos:", error);
        this.$notifications.addNotification({
          type: "danger", // Tipo de notificación (error)
          message: "Error al insertar datos",
        });
      } finally {
        this.isLoading = false; // Reset loading
      }
    },

    // Verificar si el token está presente
    checkToken() {
      return localStorage.getItem("token") !== null;
    },
    handletokenExpired() {
      this.showTokenExpiredModal = true;
      setTimeout(() => {
        this.$router.push("/login");
      }, 3000);
    },
  },
};
</script>
